import { createApp } from 'vue'
import App from './App.vue'
import store from './store'

// Importing the global css file
import './assets/styles/style.scss';

createApp(App).use(store).mount('#app')
